import { HttpService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
import { getRequestParameters, isDefined, isEndpointReady, isUndefined } from '@philips-internal/oswald-ui-utils';
function fetchLocalRecords(options, data = []) {
    const { primaryKey, value } = options;
    if (isUndefined(value)) {
        return [];
    }
    const values = Array.isArray(value) ? value : [value];
    return data.filter((item) => values.includes(item[primaryKey]));
}
function fetchRecords(options, contextData) {
    const { endpoint, parameters, primaryKey, value } = options;
    if (isUndefined(value)) {
        return Promise.resolve([]);
    }
    const requestOptions = { endpoint, parameters };
    if (!isEndpointReady(requestOptions, contextData)) {
        return Promise.resolve([]);
    }
    const values = Array.isArray(value) ? value : [value];
    const promises = [];
    for (const value of values) {
        const options = {
            endpoint: endpoint.concat(`/:${primaryKey}`),
            parameters: { ...parameters, [primaryKey]: value },
        };
        promises.push(HttpService.get(options.endpoint, getRequestParameters(options, contextData)));
    }
    return Promise.all(promises).then((results) => {
        const records = results
            .map((result) => result.body)
            .filter((body) => isDefined(body));
        return records;
    });
}
export { fetchLocalRecords, fetchRecords, };
//# sourceMappingURL=unboxed-autocomplete-utils.js.map